export default __webpack_public_path__ + "static/sean_klein-204d2ab06b0d7d886e427506d30d1828.jpg";